import { z } from 'zod';

export const RevokeGuestPassSchema = z.object({
  pass_id: z.string().uuid('Invalid pass id'),
  reason: z.string().max(500, 'Reason too long').nullable().optional(),
});

export type RevokeGuestPassInput = z.infer<typeof RevokeGuestPassSchema>;

export const RevokeMembershipQrSchema = z.object({
  membership_id: z.string().uuid('Invalid membership id'),
  reason: z.string().max(500, 'Reason too long').nullable().optional(),
});

export type RevokeMembershipQrInput = z.infer<typeof RevokeMembershipQrSchema>;
